import React from "react";

export const RoomCell = ({
  roomNumber,
  categoryName,
}: {
  roomNumber: number | string;
  categoryName?: string;
}) => {
  return (
    <div className="text-sm text-center">
      <div>{roomNumber}</div>
      {categoryName ? (
        <div className="text-xs text-gray-500">{categoryName}</div>
      ) : null}
    </div>
  );
};
